export default function initMenu() {
    // let desktop_menu: any;
    // const initDesktopMenu = () => {
    //     console.log('init desktop menu');
        // desktop_menu = document.querySelectorAll('#mainmenu');
    // };

    let mobile_menu_toggle: NodeListOf<HTMLElement>;
    const initMobileMenu = () => {
        mobile_menu_toggle = document.querySelectorAll<HTMLElement>('.mobile-menu-toggle');
        mobile_menu_toggle.forEach((el: HTMLElement) => {
            el.addEventListener('click', (e: Event) => {
                e.preventDefault();
                document.body.classList.toggle('mobile-menu-open');
                const expanded = document.body.classList.contains('mobile-menu-open') ? 'true' : 'false';
                mobile_menu_toggle.forEach((el: any) => {
                    el.setAttribute('aria-expanded', expanded);
                });
            });
        });
        document.querySelectorAll<HTMLElement>('#mobile-menu .toggle').forEach((el: HTMLElement) => {
            el.addEventListener('click', (e: Event) => {
                e.preventDefault();
                if (e.target === null) {
                    return;
                }
                (e.target as HTMLElement).closest('li')?.classList.toggle('open');
            });
        });
    }

    // Define a media query to detect screen width changes
    const mediaQuery = window.matchMedia('(max-width: 1024px)');

    // Initialize the appropriate menu based on the current screen width
    const init = () => {
        if (mediaQuery.matches) {
            initMobileMenu(); // Initialize mobile menu
        } else {
            // initDesktopMenu(); // Initialize desktop menu
        }
    }

    // Initial menu setup
    init();

    // Add an event listener to reinitialize the menu on screen width changes
    mediaQuery.addEventListener('change', init, {
        once: true
    });
}
